export enum StatusTabEnum {
    CurrentStatus = 'CurrentStatus',
    Result = 'Result'
}